module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Ack#fm-1"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbrevation#fm-2"
    }
  }, [_vm._v("List of abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#ch-1"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("An enduring word")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#sec-1"
    }
  }, [_vm._v("Our starting point")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#sec-2"
    }
  }, [_vm._v("Our strategy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#sec-3"
    }
  }, [_vm._v("The structure of our book")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#ch-2"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Pre-modern readings of Isaiah")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec-4"
    }
  }, [_vm._v("From the Old Testament to the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec-5"
    }
  }, [_vm._v("The early Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec-6"
    }
  }, [_vm._v("The Middle Ages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec-7"
    }
  }, [_vm._v("Isaiah in the Reformation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter02#sec-8"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Interpreting Isaiah in the modern era")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking Isaiah into pieces (eighteenth to mid twentieth centuries)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reassembling Isaiah (mid twentieth to twenty-first centuries)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Engaging Isaiah (late twentieth century to present)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion, assessment, and a path forward")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The history Isaiah tells")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A story of judgement and salvation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The metanarrative of Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The structure of Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your place in Isaiah’s story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Holy, holy, holy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The holy in Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiness in the story of Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holy, holy, holy in reception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Zion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What is Zion?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zion in the story of Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zion, Isaiah, and Christian reception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The messianic King")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah’s messianic hopes in historical and literary contexts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The messianic King in Isaiah’s story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah’s Messiah and Christian reception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("The Suffering Servant")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Suffering Servant in literary and historical contexts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Suffering Servant in Isaiah’s story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isaiah 53 in Christian reception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Justice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vantage points on justice in Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The God of justice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Agents of justice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Justice in the story of Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church’s reception of justice in Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Civil rights and Isaiah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter09#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10"), _c('span', {
    staticClass: "pad"
  }, [_vm._v("In the end, worship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Bibliography#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Copy_Ack#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright acknowledgements")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4290e24c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0